
import ArticleInfoBaseTemplate from '@root/modules/article/components/info/ArticleInfoBaseTemplate';
import ArticleInfoCover from '@root/modules/article/components/info/ArticleInfoCover.vue';

export default ArticleInfoBaseTemplate.extend({
  components: {
    ArticleInfoCover,
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },

    isCrArticle() {
      const articles = this.$store.getters['article/getCrArticles'];

      return articles.find((article: number) => article === this.$props.article.id);
    },
    title() {
      return this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '');
    },
  },
});
